import { CheckCircle2, Star, ExternalLink } from "lucide-react";
import { ABOUT_IMAGE, BRAND, GMB_URL } from "../mock";
import { openExternal } from "../lib/openExternal";

const POINTS = [
  "Owner-operated. every car, every coat, hands-on",
  "Climate-controlled, dust-filtered detail bay",
  "Premium 2-layer system: Crystal Serum Light + EXO v5",
  "Documented before/after for every vehicle",
];

export default function About() {
  return (
    <section id="about" className="relative py-28 md:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <div className="relative">
          <div className="absolute -top-6 -left-6 w-32 h-32 border-2 border-jester rounded-2xl" />
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={ABOUT_IMAGE}
              alt="Jester Werks ceramic coating studio in Mississauga. BMW M4 with Crystal Serum Light + EXO V5"
              loading="lazy"
              decoding="async"
              width="1200"
              height="900"
              className="w-full h-[560px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-[#120127]/70 via-transparent to-transparent" />
          </div>
          <a
            href={GMB_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute -bottom-8 -right-4 md:-right-8 bg-acid text-[#120127] p-6 rounded-2xl max-w-[260px] shadow-2xl hover:bg-[#bff020] transition-colors group block"
           onClick={(e) => { e.preventDefault(); openExternal(GMB_URL); }}>
            <div className="flex items-center gap-1 mb-2">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4"
                  style={{ color: "#120127", fill: "#120127" }}
                />
              ))}
            </div>
            <div className="font-stencil text-4xl leading-none">{BRAND.rating.count}+</div>
            <div className="text-xs uppercase tracking-[0.2em] mt-1 font-label font-bold flex items-center gap-1">
              Google reviews <ExternalLink className="w-3 h-3" />
            </div>
          </a>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
           About Jester Werks
          </div>
          <h2 className="font-display text-5xl md:text-6xl leading-[0.95]">
            <span className="text-jester">Most-reviewed.</span>
            <br />
            Most transparent.
            <br />
            <span className="font-marker text-acid text-3xl md:text-4xl inline-block mt-3">
              transparency wins.
            </span>
          </h2>
          <p className="mt-7 text-white/80 leading-relaxed text-lg">
            Jester Werks is the GTA's most-reviewed ceramic coating studio. We
            built that reputation one car, one coating, one transparent
            before/after report at a time. Every job is hand-applied in our
            climate-controlled bay using genuine Gtechniq products.
          </p>
          <p className="mt-4 text-white/70 leading-relaxed">
            No subcontractors. No upsells. No vague warranties. Just{" "}
            <strong className="text-acid">
              {BRAND.rating.count}+ verified Google reviews
            </strong>{" "}
            and{" "}
            <strong className="text-acid">1,500+ cars</strong> walking around
            Mississauga and Toronto with a finish you can actually see.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-4">
            {POINTS.map((p, i) => (
              <li key={i} className="flex items-start gap-3 text-white/85">
                <CheckCircle2 className="w-5 h-5 text-acid mt-0.5 flex-shrink-0" />
                <span className="text-sm leading-relaxed">{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-wrap gap-8 border-t border-white/10 pt-8">
            <div>
              <div className="font-stencil text-3xl text-jester">5-YR</div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50 mt-1 font-label">
                Coating warranty
              </div>
            </div>
            <div>
              <div className="font-stencil text-3xl text-jester">24H</div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50 mt-1 font-label">
                Quote turnaround
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
